module.exports = __webpack_public_path__ + "img/mymedal1.35e40fe1.png";